import { useMemo } from 'react';
import { usePublicMarkets } from '../services/marketService';
import { toMarketSelectOptions } from '../utils/marketOptions';

/**
 * Markets are where the marketplace operates. Country catalog is not used here.
 * activeOnly: status is active. bookableOnly: active and open for bookings.
 */
export default function useOperatingMarkets({ bookableOnly = false, activeOnly = false } = {}) {
  const params = bookableOnly
    ? { bookable_only: true }
    : activeOnly
      ? { bookable_only: false, status: 'active' }
      : { bookable_only: false };
  const query = usePublicMarkets(params);
  const markets = query.data?.data || [];
  const options = useMemo(() => toMarketSelectOptions(markets), [markets]);

  return {
    markets,
    options,
    isLoading: query.isLoading,
    error: query.error,
    isEmpty: !query.isLoading && options.length === 0,
  };
}
